import React from "react";
import "./MobileMenu.scss";
import { ReactComponent as Dashboard } from "../../assets/icons/dashboard.svg";
import { ReactComponent as Cases } from "../../assets/icons/ate_cases.svg";
import { ReactComponent as Maintenance } from "../../assets/icons/maintenance-request.svg";
import { ReactComponent as Appointments } from "../../assets/icons/preventive-appointment.svg";
import { ReactComponent as Property } from "../../assets/icons/building.svg";
import { ReactComponent as Invoices } from "../../assets/icons/view-invoice.svg";
import { RoutePaths } from "src/resources/enum";
import { To, Link, Path } from "react-router-dom";
import { Button } from "primereact/button";
import NavUserDropdown from "../NavUserDropdown/NavUserDropdown";
import { ReactComponent as LoginIcon } from "../../assets/icons/login-icon.svg";
import { ReactComponent as RegisterBMCIcon } from "../../assets/icons/register-bmc-icon.svg";
import { useTranslation } from "react-i18next";
import { isCivilDefenseUser } from "src/utils/helpers";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { Sidebar } from "primereact/sidebar";
import NavLinkWithIcon from "../NavLinkWithIcon/NavLinkWithIcon";
import { ReactComponent as ListSubsetIndicatorIcon } from "src/assets/icons/list-subset-indicator.svg";
import DomainOutlinedIcon from "@mui/icons-material/DomainOutlined";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";

type MobileMenuProps = {
  isMobileMenuOpen: boolean;
  isLoggedIn: boolean;
  toggleMobileMenu: () => void;
  handleClick: (path: To) => void;
};
const MobileMenu = ({
  isMobileMenuOpen,
  isLoggedIn,
  handleClick,
  toggleMobileMenu,
}: MobileMenuProps) => {
  const { t } = useTranslation(["common"]);

  const civilDefenseLinksList = [
    {
      label: t("dashboard"),
      Icon: Dashboard,
      href: RoutePaths.CDDashboard,
    },
    {
      label: t("maintenanceFaults"),
      Icon: Cases,
      href: RoutePaths.AllCases,
    },
    {
      label: t("breachedMaintenanceFaults"),
      Icon: ListSubsetIndicatorIcon,
      href: RoutePaths.BreachedCases,
      iconClasses: "subset-icon",
    },
    {
      label: t("preventiveAppointments"),
      Icon: Appointments,
      href: RoutePaths.PreventiveAppointment,
    },
    {
      label: t("breachedPreventiveAppointments"),
      Icon: ListSubsetIndicatorIcon,
      href: RoutePaths.BreachedPreventiveAppointments,
      iconClasses: "subset-icon",
    },
    {
      label: t("bmcWithRating"),
      Icon: DomainOutlinedIcon,
      href: RoutePaths.BMCWithRating,
    },
    {
      label: t("sendRequestToBMC"),
      Icon: NoteAltOutlinedIcon,
      href: RoutePaths.SendRequestToBMC,
    },
  ];

  const bmcUserLis = [
    {
      label: t("dashboard"),
      Icon: Dashboard,
      href: RoutePaths.Dashboard,
    },
    {
      label: t("ateCases"),
      Icon: Cases,
      href: RoutePaths.ATECases,
    },
    {
      label: t("maintenanceRequests"),
      Icon: Maintenance,
      href: RoutePaths.MaintenanceRequests,
    },
    {
      label: t("preventiveAppointments"),
      Icon: Appointments,
      href: RoutePaths.PreventiveAppointment,
    },
    {
      label: t("assignedBuildings"),
      Icon: Property,
      href: RoutePaths.AssignedBuildings,
    },
    { label: t("viewInvoices"), Icon: Invoices, href: RoutePaths.ViewInvoices },
  ];

  const loggedInLinksList = isCivilDefenseUser()
    ? civilDefenseLinksList
    : bmcUserLis;
  const handleLinkClick = (path: string | Partial<Path>) => {
    handleClick(path);
    toggleMobileMenu();
  };
  return (
    <Sidebar
      className="mobile__nav"
      visible={isMobileMenuOpen}
      onHide={toggleMobileMenu}
    >
      <div className="nav__list">
        {isLoggedIn ? (
          <div className="list__section">
            <NavUserDropdown toggleMobileMenu={toggleMobileMenu} />
          </div>
        ) : (
          <div className="list__section login__section  gap-2">
            <Button
              className="light-primary-btn login-btn my-0 mx-2"
              onClick={() => handleLinkClick(RoutePaths.Login)}
            >
              <LoginIcon />
              {t("login")}
            </Button>
            <Button
              className="primary-btn m-0 register-btn"
              onClick={() => handleLinkClick(RoutePaths.Register)}
            >
              <RegisterBMCIcon />
              {t("bmcRegister")}
            </Button>
          </div>
        )}

        <div className="separator"></div>
        {isLoggedIn && (
          <div className="list__section">
            {loggedInLinksList.map(({ href, ...item }, _ndx) => (
              <NavLinkWithIcon
                handleClick={toggleMobileMenu}
                key={_ndx}
                href={`${href}`}
                {...item}
              />
            ))}

            <div className="separator"></div>
          </div>
        )}

        <div className="list__section gap-4">
          <LanguageSelector handleClick={toggleMobileMenu}  />
        </div>
      </div>
    </Sidebar>
  );
};

export default MobileMenu;
